import apiClient from './apiClient';
import { ProfileWithUser, SwipeResponse, Match } from '../types';

export const matchingApi = {
  getRecommendations: async (): Promise<ProfileWithUser[]> => {
    const response = await apiClient.get<ProfileWithUser[]>('/swipe/recommendations');
    return response.data;
  },

  swipe: async (swipedUserId: string, action: 'like' | 'dislike'): Promise<SwipeResponse> => {
    const response = await apiClient.post<SwipeResponse>('/swipe', {
      swipedUserId,
      action,
    });
    return response.data;
  },

  getMatches: async (): Promise<Match[]> => {
    const response = await apiClient.get<Match[]>('/match');
    return response.data;
  },
};
